import { render, staticRenderFns } from "./VuesticWidget.vue?vue&type=template&id=7b10d81b&"
import script from "./VuesticWidget.vue?vue&type=script&lang=js&"
export * from "./VuesticWidget.vue?vue&type=script&lang=js&"
import style0 from "./VuesticWidget.vue?vue&type=style&index=0&id=7b10d81b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports